import { BASE_URL } from 'config';
import { useEffect, useState } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import DataTable from "examples/Tables/DataTable";
import storesTableData from "./data/storesTableData";
import TextField from "@mui/material/TextField";
import MDButton from "components/MDButton";
import AddStoreModal from "components/AddStoreModal";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {
  CircularProgress,
  Backdrop,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import RowsPerPageSelector from "components/RowsPerPageSelector";
import { Subscript } from "@mui/icons-material";
import SubscriptionForm from "layouts/subscriptions/SubscriptionForm";

function Stores() {
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [stores, setStores] = useState([]);
  const [search, setSearch] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState("all");
  const [subscriptionModel, setSubscriptionModel] = useState(false);

  const handleSubscriptionClick = (store) => {
    setCurrentUser(store);
    setSubscriptionModel(true);
  };
  const handleEditClick = (store) => {
    setCurrentUser(store);

    setModalOpen(true);
  };

  useEffect(() => {
    fetchStores();
  }, [page]);

  const fetchStores = async () => {
    setLoading(true);
    const token = localStorage.getItem("user-token");
    try {
      const response = await fetch(
        `${BASE_URL}/administrator/stores?page=${page}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const data = await response.json();
      console.log("data", data);
      setPage(data.current_page);
      setTotalPages(data.last_page);
      setStores(data.data || []);
    } catch (error) {
      console.error("Error fetching stores:", error);
    }
    setLoading(false);
  };
  // show all stores , search by name , show in table
  const fetchFilteredStores = async (searchValue, selectedStatus) => {
    setLoading(true);
    const token = localStorage.getItem("user-token");
    const queryParams = new URLSearchParams({
      name: searchValue || "",
      merchant_name: searchValue || "",
      status: selectedStatus === "all" ? "" : selectedStatus,
    });

    try {
      const response = await fetch(
        `${BASE_URL}/administrator/stores/filters?${queryParams}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const data = await response.json();
      setStores(data.data || []);
      setPage(0);
    } catch (error) {
      console.error("Error filtering stores:", error);
    }
    setLoading(false);
  };

  const { columns, rows } = storesTableData(
    stores,
    handleEditClick,
    handleSubscriptionClick,
    fetchStores
  );

  return (
    <>
      <Backdrop open={loading} sx={{ zIndex: 2000 }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <AddStoreModal
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
          setCurrentUser(null);
        }}
        onUserAdded={fetchStores}
        initialData={currentUser}
      />

      {subscriptionModel && (
        <SubscriptionForm
          open={subscriptionModel}
          onClose={() => {
            setSubscriptionModel(false);
            setCurrentUser(null);
          }}
          store={currentUser}
        />
      )}

      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            borderRadius="lg"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{ background: "linear-gradient(90deg, #ca9937, #e0b15a)", boxShadow: 3 }}
          >
            <MDTypography variant="h6" color="white">
              قائمة المتاجر
            </MDTypography>
            <MDButton
              variant="contained"
              color="white"
              startIcon={<AddIcon />}
              sx={{ color: "white" }}
              onClick={() => setModalOpen(true)}
            >
              متجر جديد
            </MDButton>
          </MDBox>

          <MDBox pt={3} px={2}>
            <MDBox display="flex" gap={2} mb={3}>
              <TextField
                fullWidth
                label="بحث بالاسم أو البريد"
                variant="outlined"
                size="small"
                sx={{ mb: 3 }}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    fetchFilteredStores(search, status);
                  }
                }}
              />
              <FormControl size="small" sx={{ minWidth: 180 }}>
                <InputLabel id="status-label">حالة المتجر</InputLabel>
                <Select
                  labelId="status-label"
                  value={status}
                  label="حالة المتجر"
                  onChange={(e) => {
                    const newStatus = e.target.value;
                    setStatus(newStatus);
                    fetchFilteredStores(search, newStatus);
                  }}
                  sx={{ height: "40px" }}
                >
                  <MenuItem value="all">الكل</MenuItem>
                  <MenuItem value={0}>جديد</MenuItem>
                  <MenuItem value={1}>مقبول</MenuItem>
                  <MenuItem value={2}>قيد المراجعة</MenuItem>
                  <MenuItem value={3}>معلق مؤقتًا</MenuItem>
                  <MenuItem value={4}>معلق</MenuItem>
                  <MenuItem value={5}>محظور</MenuItem>
                </Select>
              </FormControl>
            </MDBox>

            <MDBox mb={2} display="flex">
              <RowsPerPageSelector value={rowsPerPage} onChange={setRowsPerPage} />
            </MDBox>
            <DataTable
              table={{ columns, rows }}
              isSorted={false}
              entriesPerPage={false}
              showTotalEntries={true}
              noEndBorder
              sx={{
                "& .MuiTable-root": { minWidth: 1000 },
                "& .MuiTableCell-root": {
                  py: 1.5,
                  borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
                },
                "& .MuiTableHead-root": {
                  backgroundColor: (theme) => theme.palette.grey[100],
                },
              }}
            />


          </MDBox>
        </Card>
      </MDBox>
      <MDBox display="flex" justifyContent="center" mt={4} pb={4} px={2}>
        <MDButton
          onClick={() =>
            setPage((prev) => {
              if (prev === 1) {
                return prev;
              }
              return prev - 1;
            })
          }
          disabled={page === 1}
          sx={{
            background: "linear-gradient(90deg, #ca9937, #e0b15a)",
            color: "text.main",
            borderRadius: "50%",
            width: "50px",
            height: "50px",
            minWidth: "50px",
            mx: 1,
            "&:hover": {
              background: "linear-gradient(90deg, #b6842f, #d39d45)",
            },
          }}
        >
          <ArrowForwardIcon />
        </MDButton>

        <MDTypography
          variant="button"
          color="text"
          sx={{ display: "flex", alignItems: "center", mx: 3, fontWeight: "bold" }}
        >
          {page}
          / {totalPages}
        </MDTypography>

        <MDButton
          onClick={() =>
            setPage((prev) => {
              if (prev === totalPages) {
                return prev;
              }
              return prev + 1;
            })
          }
          disabled={page === totalPages}
          sx={{
            background: "linear-gradient(90deg, #ca9937, #e0b15a)",
            color: "text.main",
            borderRadius: "50%",
            width: "50px",
            height: "50px",
            minWidth: "50px",
            mx: 1,
            "&:hover": {
              background: "linear-gradient(90deg, #b6842f, #d39d45)",
            },
          }}
        >
          <ArrowBackIcon />
        </MDButton>
      </MDBox>
    </>
  );
}

export default Stores;
